export default function (instance, user) {
    const {can, cannot} = instance;
    const isAdmin = user?.roles.includes(`Admin`);
    const isTop = user?.roles.includes(`Top`);
    const isStaff = user?.roles.includes(`Staff`);
    const isPTO_BY = user?.roles.includes(`PTO_BY`);
    const isPTO_RU = user?.roles.includes(`PTO_RU`);
    const isCurator = user?.roles.includes(`Curator`);
    const isAudit_BY = user?.roles.includes(`Audit_BY`);
    const isAudit_RU = user?.roles.includes(`Audit_RU`);        

    if (isAdmin) {
        can('manage', 'all');
        cannot('manage', 'adminPanel');
        if ([`Spike`, `dashkevich`].includes(user?.login)) {
            can('manage', 'adminPanel');
        }
    }

    can('read', 'requests');
    can('read', 'mechanicAssets');
    if (isStaff || isTop || isCurator || isPTO_BY || isPTO_RU || isAudit_BY || isAudit_RU) {
        can('create', 'requests');
    }

    if (isTop) {
        can(`read`, `users`);
        can(`read`, `systemUsers`);
        can(`read`, `objects`);
        can(`read`, `objectsInProcess`);
        can(`read`, `workTypes`);
        can(`read`, `workShifts`);
        can(`read`, `completedWorks`);
        can(`read`, `targets`);
        can(`read`, `secondWorks`);
        can(`read`, `fuelLimits`);
        can(`read`, `fuelCards`);
        can(`create`, `mechanicAssets`);
        can(`update`, `mechanicAssets`);
        can(`delete`, `mechanicAssets`);
        can(`read`, `usedFuels`);

    }

    if (isPTO_BY || isPTO_RU) {
        can(`read`, `users`);
        can(`create`, `objects`);
        can(`delete`, `objects`);
        can(`read`, `objects`);
        can(`create`, `objectsInProcess`);
        can(`update`, `objectsInProcess`);
        can(`read`, `objectsInProcess`);
        can(`create`, `workTypes`);
        can(`read`, `workTypes`);
        can(`read`, `workShifts`);
        can(`read`, `completedWorks`);
        can(`create`, `targets`);
        can(`read`, `targets`);
        can(`update`, `targets`);
        can(`delete`, `targets`);
        can(`read`, `secondWorks`);
        can(`read`, `fuelLimits`);
        can(`read`, `fuelCards`);
        can(`read`, `usedFuels`);
        can(`read`, `materials`);
        can(`create`, `materials`);
        can(`update`, `materials`);
        can(`delete`, `materials`);
        can(`create`, `materialTargets`);
        can(`read`, `materialTargets`);
        can(`update`, `materialTargets`);
        can(`delete`, `materialTargets`);
        can(`read`, `materialUsing`);
        can(`create`, `materialGroups`);
        can(`read`, `materialGroups`);
        can(`update`, `materialGroups`);
        can(`delete`, `materialGroups`);

    }

    if (isPTO_BY) {
        can(`create`, `objectBY`);
    }

    if (isPTO_RU) {
        can(`create`, `objectRU`);
    }

    if (isCurator) {
        can(`read`, `objects`);
        can(`read`, `objectsInProcess`);
        can(`read`, `workTypes`);
        can(`read`, `workShifts`);
        can(`read`, `completedWorks`);
        can(`read`, `targets`);
        can(`read`, `secondWorks`);
        can(`read`, `fuelLimits`);
        can(`create`, `fuelLimits`);
        can(`update`, `fuelLimits`);
        can(`delete`, `fuelLimits`);
        can(`read`, `fuelCards`);
        can(`create`, `fuelCards`);
        can(`update`, `fuelCards`);
        can(`delete`, `fuelCards`);
        can(`read`, `usedFuels`);

        can(`read`, `materials`);
        can(`read`, `materialTargets`);
        can(`read`, `materialUsing`);
        can(`read`, `materialGroups`);
    }

    if (isStaff) {
        can(`read`, `objects`);
        can(`read`, `objectsInProcess`);
        can(`read`, `workTypes`);
        can(`read`, `targets`);
        can(`read`, `completedWorks`);
        can(`read`, `secondWorks`);
        can(`read`, `fuelLimits`);
        can(`read`, `fuelCards`);
        can(`read`, `usedFuels`);

        can(`read`, `workShifts`);
    }

    if (isAudit_BY || isAudit_RU) {
        can(`read`, `users`);
        can(`read`, `objects`);
        can(`read`, `objectsInProcess`);
        can(`read`, `workTypes`);
        can(`read`, `workShifts`);
        can(`read`, `completedWorks`);
        can(`read`, `targets`);
        can(`read`, `secondWorks`);
        can(`read`, `fuelLimits`);
        can(`read`, `fuelCards`);
        can(`read`, `usedFuels`);

        can(`read`, `materials`);
        can(`read`, `materialTargets`);
        can(`read`, `materialUsing`);
        can(`read`, `materialGroups`);
    }

    if (isStaff || isCurator || isAdmin) {
        can(`read`, `shiftReportMaster`);
    }

    const abilities = user && user.abilities ? user.abilities : {};
    const materialAbilities = abilities.materials || {};
    const objectAbilities = abilities.objects || {};
    const galleryAbilities = abilities.gallery || {};
    const reportsAbilities = abilities.reports || {};

    if (materialAbilities.read) {
        can(`read`, `materials`);
        can(`read`, `materialGroups`);
    }

    if (materialAbilities.create) {
        can(`create`, `materials`);
        can(`create`, `materialGroups`);
    }

    if (materialAbilities.update) {
        can(`update`, `materials`);
        can(`update`, `materialGroups`);
    }

    if (materialAbilities.delete) {
        can(`delete`, `materials`);
        can(`delete`, `materialGroups`);
    }

    if (objectAbilities.read) {
        can(`read`, `objects`);
        can(`read`, `objectsInProcess`);
    }

    if (objectAbilities.create) {
        can(`create`, `objects`);
        can(`create`, `objectsInProcess`);
    }

    if (objectAbilities.update) {
        can(`update`, `objects`);
        can(`update`, `objectsInProcess`);
    }

    if (objectAbilities.delete) {
        can(`delete`, `objects`);
        can(`delete`, `objectsInProcess`);
    }

    if (galleryAbilities.read) {
        can(`read`, `gallery`);
    }

    if (reportsAbilities.read) {
        can(`read`, `reports`);
    }

    if (user && user.abilities && user.abilities.charts && user.abilities.charts.read) {
        can('read', 'chartsPage');
    }

    cannot('delete', 'Post', {published: true});
    return instance;
}
